// Verified against https://www.recoopinsurance.com/contact on 2026-09-13.
export const SUPPORT_PHONE = "877-273-2667";
export const SUPPORT_PHONE_LABEL = `877-2RECOOP (${SUPPORT_PHONE})`;
export const SUPPORT_EMAIL = "support@recoopinsurance.com";

export function phoneHref(phone: string): string {
  const [number, extension] = phone.trim().split(/\s*(?:ext\.?|x|#)\s*/i);
  const digits = number.replace(/\D/g, "");
  const international = number.startsWith("+") || (digits.length === 11 && digits.startsWith("1"));
  const dial = international ? `+${digits}` : digits.length === 10 ? `+1${digits}` : digits;
  const extensionDigits = extension?.replace(/\D/g, "");
  return `tel:${dial}${extensionDigits ? `;ext=${extensionDigits}` : ""}`;
}

export const SUPPORT_PHONE_HREF = phoneHref(SUPPORT_PHONE);
